<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper4.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" :checkMenu="menu" :rightBars="rightBars"></menutree>
    <div class="reprot_box">
      <div style="width: 1000px;height: 1150px;background: #FFFFFF;">
         <iframe id="myIframe" :src="pdfUrl" style="background-color: #FFFFFF;" width="100%" height="100%" frameborder="0"></iframe>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
// import Pdfh5 from "pdfh5"
// import "pdfh5/css/pdfh5.css"
export default {
  name:'reportInfo',
  components:{top,menutree,bottom},
  data () {
    return {
      reportInfo:{},
      pdfUrl:'',
      id:'',
      menuchild:[{
        lable:'职业卫生报告',
        value:'1',
        path:'/reports'
      },{
        lable:'信息公示',
        value:'3',
        path:'/publicNotice'
      },{
        lable:'新闻资讯',
        value:'2',
        path:'/newsList'
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'信息公开',
        path:'',
      },{
        lable:'信息公示',
        path:'',
      }]
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.menu = this.$route.query.menu;
    document.getElementById('myIframe').onload = function() {
        var iframe = this;
        var doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.body.style.backgroundColor = 'white';
    };
    this.getData()
  },
  methods:{
    getData(){
      const url=`https://api.hzshjc.com/index/caseInfo/${this.id}`;
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background:'rgba(0, 0, 0, 0)'
      });
      this.$axios({
        method:'get',
        url:url
      }).then(res=>{
        if(res.data.code=='200'){
          this.reportInfo = res.data.data;
          this.pdfUrl = 'https://www.hzshjc.com'+ this.reportInfo.livingPic + '?page=hsn#toolbar=0';
        }
        loading.close();
      })
    }
  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .reprot_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
    .title{
      height: 50px;
      font-size: 16px;
      color: #666;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .marks{
      font-size: 12px;
      color: #999;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .table{
      border: 1px solid #f0f0f0;
      margin:10px 0;
      color: #666;
      font-size: 14px;
      .table_tit{
        font-size: 16px;
        font-weight: bolder;
        color: #333;
        height: 50px;
        border-bottom: 1px solid #f0f0f0;
      }
      .line{
        display: flex;
        height: 50px;
        border-bottom: 1px solid #f0f0f0;
        .line_label{
          width:200px;
          padding:0 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          border-right: 1px solid #f0f0f0;
        }
        .line_cont_one{
          width: 920px;
          padding:0 20px;
          display: flex;
          align-items: center;
        }
        .line_cont_two{
          width: 320px;
          padding:0 20px;
          display: flex;
          align-items: center;
          border-right: 1px solid #f0f0f0;
        }
        .line_cont_two:last-child{
          border-right:none
        }
      }
      .line_hearf{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        border-bottom: 1px solid #f0f0f0;
        min-height: 40px;
        line-height: 40px;
        padding:10px;
        img{
          width: calc(50% - 5px);
          margin: 5px 0;
        }
        .line_l{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 600px;
          border-right: 1px solid #f0f0f0;
          img{
            width: 90%;
            margin: 5px 0;
          }
        }
        .line_r{
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          width: 600px;
          border-right: 1px solid #f0f0f0;
          img{
            width: 90%;
            margin: 5px 0;
          }
        }
      }
      .line_hearf:last-child{
        border-bottom: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/reports/reportInfo.vue